"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  display: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Text = _styledComponents["default"].div(_templateObject(), _styledSystem.space, _styledSystem.typography, _styledSystem.color, _styledSystem.layout, (0, _styledSystem.system)({
  textTransform: true
}), function (_ref) {
  var display = _ref.display;
  return display || 'block';
});

var _default = Text;
exports["default"] = _default;

//# sourceMappingURL=Text.js.map